import VueRouter from 'vue-router';
import complaintProblem from './complaints-problem/complaints-problem.vue';
import complaintsPersonal from './complaints-personal/complaints-personal.vue';
import complaintsSummary from './complaints-summary/complaints-summary.vue';
import complaintsProgressBar from './complaints-progress-bar/complaints-progress-bar';
import complaintsTechnicalError from './complaints-technical-error/complaints-technical-error.vue';
import complaintsSuccess from './complaints-success/complaints-success.vue';
import { ROUTE_NAMES } from './constants/complaint-constants';
import { mapState, mapActions, mapGetters } from 'vuex';
import VueProgress from '@ui-common/vue-progress';

const routes = [
	{ path: ROUTE_NAMES.PROBLEM, component: complaintProblem },
	{ path: ROUTE_NAMES.PERSONAL, component: complaintsPersonal },
	{ path: ROUTE_NAMES.SUMMARY, component: complaintsSummary },
	{ path: '*', redirect: ROUTE_NAMES.PROBLEM }
];

export const router = new VueRouter({
	routes
});

export default {
	props: {
		privacyPolicyUrl: {
			required: false,
			default: 'https://www.otpbank.hu/static/portal/sw/file/adatkezelesi_tajakoztato_irjon_nekunk.pdf'
		}
	},
	router,
	components: {
		complaintsProgressBar,
		complaintsTechnicalError,
		complaintsSuccess,
		VueProgress
	},
	methods: {
		...mapActions('complaints', ['initFirstStep', 'getInitData']),
		scrollToContainer() {
			const elem = this.$refs['complaints-container'];
			if (elem) {
				this.$scrollTo(elem);
			}
		}
	},
	computed: {
		...mapState('complaints', ['visitedPages', 'validPages', 'currentPage', 'technicalError', 'completed']),
		...mapGetters('complaints', ['isOnFirstPage'])
	},
	created() {
		this.getInitData(this.$i18n.locale);
		this.initFirstStep(ROUTE_NAMES.PROBLEM);
	},
	watch: {
		$route(to) {
			if (to.query.scrollError) {
				return;
			} else {
				let elem = this.$refs['complaints-container'];
				if (elem) {
					this.$nextTick(() => {
						this.$scrollTo(elem);
						elem.querySelector('h2').focus();
					});
				}
			}
		},
		technicalError(newValue) {
			if (newValue) {
				this.scrollToContainer();
			}
		},
		completed(newValue) {
			if (newValue) {
				this.scrollToContainer();
			}
		}
	}
};
